import { render, staticRenderFns } from "./users-list.vue?vue&type=template&id=0d658bcc&scoped=true"
import script from "./users-list.vue?vue&type=script&lang=js"
export * from "./users-list.vue?vue&type=script&lang=js"
import style0 from "./users-list.vue?vue&type=style&index=0&id=0d658bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d658bcc",
  null
  
)

export default component.exports